import { BrowserRouter } from 'react-router-dom';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import Content from 'routes/Routes';

const App = () =>
  <BrowserRouter>
    <Header />
    <Content />
    <Footer />
  </BrowserRouter>;

export default App;
